// `/campaigns/*` sub-tree layout — passes the outlet through unmodified.
// Wave 5d Agent 5d.1.

import { Outlet, createRoute } from '@tanstack/react-router';

import { Route as AuthedLayoutRoute } from '../__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: 'campaigns',
  component: CampaignsLayout,
});

function CampaignsLayout() {
  return <Outlet />;
}
